import { useEffect, useState } from 'react';
import { Alert, Button } from '@nimbus-ds/components';
import { getTodayIsoString, subtractDays } from 'commons/utils/date';
import { defaultStockIssuesFilters } from 'domains/Orders/constants';
import {
  defaultFilters,
  FiltersParamsType,
} from 'domains/Orders/Orders/ordersService';
import {
  trackingOrdersStockIssuesAlertDismiss,
  trackingOrdersStockIssuesButtonClick,
  trackingOrdersStockIssuesShowAlert,
} from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface StockIssuesAlertProps {
  show: boolean;
  handleFilterStockIssuesOrders: (newFilters: FiltersParamsType) => void;
}

function StockIssuesAlert({
  show,
  handleFilterStockIssuesOrders,
}: Readonly<StockIssuesAlertProps>) {
  const [showAlert, setShowAlert] = useState(show);
  const t = useTranslationOrders('stockIssuesAlert');
  const today = getTodayIsoString();
  const lastSevenDays = subtractDays(today, 7);

  useEffect(() => {
    setShowAlert(show);
    if (show) {
      trackingOrdersStockIssuesShowAlert();
    }
  }, [show]);

  const handleButtonClick = () => {
    handleFilterStockIssuesOrders({
      ...defaultFilters,
      ...defaultStockIssuesFilters,
      dateFrom: lastSevenDays,
      dateTo: today,
    });
    trackingOrdersStockIssuesButtonClick();
  };

  const handleAlertRemove = () => {
    localStorage.setItem(
      'orders-list-stock-issues-ts',
      new Date().toISOString(),
    );
    setShowAlert(false);
    trackingOrdersStockIssuesAlertDismiss();
  };

  return (
    <Alert show={showAlert} appearance="warning" onRemove={handleAlertRemove}>
      {t('title')}
      <Button onClick={handleButtonClick}>{t('button')}</Button>
    </Alert>
  );
}

export default StockIssuesAlert;
